module.exports = __webpack_public_path__ + "static/media/G1-23-Yrís-Hatzis-cod54-B.1472d8c5.png";